import DealsTableList from "./DealsTableList";

import AccessControlDealsTableList from "./AccessControl/DealsTableList";
import { UsersIcon } from "../Icons";
import { useState } from "react";
import { useGetDealTrackerDataQuery } from "../../store/apiSlices/dealTracker";
import Tabs from "../Shared/Tabs";

export default function SheetsTab() {
  const [activeTab, setActiveTab] = useState(0);
  const { data } = useGetDealTrackerDataQuery();

  const myTables = Object.values(data?.data ?? {}).flat();
  const accessControlTables = Object.values(
    data?.access_control_data ?? {},
  ).flat();

  const tabs = [
    {
      label: `My Sheets (${myTables.length})`,
    },
    {
      label: (
        <div className="flex items-center gap-2">
          <UsersIcon className="size-4 ml-1 text-gray-600" />

          <p className="text-gray-800 tracking-wide">
            Shared with you{" "}
            <span className="text-gray-500">
              ({accessControlTables.length})
            </span>
          </p>
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="flex mb-6">
        <Tabs.List
          tabs={tabs}
          activeIndex={activeTab}
          onChange={(idx: number) => setActiveTab(idx)}
          className="max-w-sm"
        />

        <div className="flex-1 border-b-[2px] border-gray-200"></div>
      </div>

      <Tabs activeIndex={activeTab}>
        <Tabs.Tab>
          <DealsTableList />
        </Tabs.Tab>

        <Tabs.Tab>
          <AccessControlDealsTableList />
        </Tabs.Tab>
      </Tabs>
    </>
  );
}
